exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ff-checkbox {\n\t& > input {\n\t\tdisplay: none;\n\t}\n\n\t& > label {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 12px;\n\t\t& > .check {\n\t\t\tcursor: pointer;\n\t\t\ttransition: all 0.2s ease-out;\n\t\t}\n\t\t& > .label {\n\t\t\tline-height: 1.3;\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n}\n", ""]);

// exports
